var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"buttons":['cancel'],"extra-large":"","hide-header":"","persistent":""}},[_c('Form',{attrs:{"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }